import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import ExperienceSection from './components/ExperienceSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import WhyFractionalSection from './components/WhyFractionalSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import TestimonialsSection from './components/TestimonialsSection';

const Home = () => {
  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const backToTopButton = document.getElementById('back-to-top');
    if (backToTopButton) {
      backToTopButton.addEventListener('click', handleScrollToTop);
    }

    const handleScroll = () => {
      if (backToTopButton) {
        if (window.scrollY > 300) {
          backToTopButton.classList.remove('hidden');
        } else {
          backToTopButton.classList.add('hidden');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      if (backToTopButton) {
        backToTopButton.removeEventListener('click', handleScrollToTop);
      }
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <ExperienceSection />
      <ServicesSection />
      <WhyFractionalSection />
      <ProcessSection />
      <AboutSection />
      <ContactSection />
      <TestimonialsSection />
      <Footer />

      <button
        id="back-to-top"
        className="fixed bottom-8 right-8 w-12 h-12 flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition-all duration-300 hidden cursor-pointer z-40"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default Home;